import React from 'react';

import * as dates from 'date-arithmetic';

import { Navigate } from 'react-big-calendar';

import CustomTimeGrid from './CustomTimeGrid';

class CustomWeekView extends React.Component {
  mergeVacationsData(prevData, nextData) {
    const { colleagues: prevColleagues } = prevData;
    const { colleagues: nextColleagues } = nextData;

    if (prevColleagues && nextColleagues) {
      let newData = [...prevColleagues];
      nextColleagues.forEach((e) => {
        const colleagueIndex = newData.findIndex((el) => +e.user.id === +el.user.id);

        if (colleagueIndex !== -1) {
          newData = [
            ...newData.slice(0, colleagueIndex),
            ...newData.slice(colleagueIndex + 1),
            {
              ...newData[colleagueIndex],
              leaverequestSet: [
                ...(newData[colleagueIndex].leaverequestSet || []),
                ...e.leaverequestSet.filter(
                  (event) => newData[colleagueIndex].leaverequestSet?.findIndex((ev) => +event.id === +ev.id) === -1
                ),
              ],
            },
          ];
        }
      });
      return newData;
    }
    return [];
  }

  componentDidUpdate(prevProps) {
    const { variables, refetch } = this.props;
    if (
      Object.keys(variables).length &&
      (prevProps.variables.endDate !== this.props.variables.endDate ||
        prevProps.variables.startDate !== this.props.variables.startDate)
    ) {
      refetch(variables);
    }
  }

  render() {
    let { date, range, ...props } = this.props;

    return <CustomTimeGrid {...props} range={range} eventOffset={15} className={'week-view'} />;
  }
}

CustomWeekView.range = (date) => {
  let start = dates.add(dates.startOf(date, 'week'), 1, 'day');
  let end = dates.add(start, 6, 'day');

  let current = start;
  let range = [];

  while (dates.lte(current, end, 'day')) {
    range.push(current);
    current = dates.add(current, 1, 'day');
  }

  return range;
};

CustomWeekView.navigate = (date, action) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return dates.add(date, -1, 'week');

    case Navigate.NEXT:
      return dates.add(date, 1, 'week');

    default:
      return date;
  }
};

CustomWeekView.title = (date) => (
  <div className="toolbar__label" data-testid="calendar-date">
    <div className="label-title">{date.toLocaleString('default', { month: 'long' })}</div>
    <div className="label-text">{date.getFullYear()}</div>
  </div>
);

export default CustomWeekView;
